import { API_ENDPOINT } from "../constants";

export const getCartCollection = (api, event_id, user_profile_id, index_id) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("user_profile_id", user_profile_id);
      formData.append("index_id", index_id);

    return fetch(`${API_ENDPOINT}/get-my-event-cart-collection`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

export const saveCollectionIfExisting = (api, event_id, selfie_url, images) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("selfie_url", selfie_url);

    return fetch(`${API_ENDPOINT}/save-collection`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

export const saveCollectionIfNotExisting = (api, event_id, selfie_url, contact, otp, country_code, is_whatsapp_allow=1, images) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("selfie_url", selfie_url);
      formData.append("contact", contact);
      formData.append("otp", otp);
      formData.append("country_code", country_code);
      formData.append("is_whatsapp_allow", is_whatsapp_allow);

    return fetch(`${API_ENDPOINT}/save-collection`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

export const addPhotoToCart = (api, event_id, user_profile_id, images ,price) => {
    console.log('Images', images);
    let formData = new FormData();
        formData.append("api_key", api);
        formData.append("event_id", event_id);
        formData.append("user_profile_id", user_profile_id);        


        images.map((image, index) => {
            formData.append(`photo_details[${index}][image_name]`, image.image_name)
            formData.append(`photo_details[${index}][image_price]`, price)
        })


        console.log(formData, "FORMDATA");


    return fetch(`${API_ENDPOINT}/cart-add-photo`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

export const registerAndAddPhotoToCart = (event_id, selfie_url, contact, otp, country_code, is_whatsapp_allow, images, price) => {
    let formData = new FormData();
        formData.append("event_id", event_id);
        formData.append("selfie_url", selfie_url);
        formData.append("contact", contact);
        formData.append("otp", otp);
        formData.append("country_code", country_code);
        formData.append("is_whatsapp_allow", is_whatsapp_allow);

        images.map((image, index) => {
            formData.append(`photo_details[${index}][image_name]`, image.image_name)
            formData.append(`photo_details[${index}][image_price]`, price)
        })


        console.log(formData, "FORMDATA");


    return fetch(`${API_ENDPOINT}/cart-add-photo`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};


export const deletePhotoFromCart = (api, event_id, user_profile_id, image_name) => {
    let formData = new FormData();
    formData.append("api_key", api);
    formData.append("event_id", event_id);
    formData.append("user_profile_id", user_profile_id);
    formData.append("image_name", image_name);


    return fetch(`${API_ENDPOINT}/cart-delete-photo`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

